import { Box, Stack, TextField, Typography } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
// import moment from "moment";
// import React, { useState } from "react";

const DatePanel = ({ filter, setFilter }) => {
  // const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  // const [toDate, setToDate] = useState(moment().format());

  
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="From date"
            value={filter.date_iso_after}
            onChange={(value) =>
              // setFromDate(value)
              setFilter({ ...filter, date_iso_after: value })
            }
            renderInput={(params) => (
              <TextField fullWidth variant="outlined" {...params} />
            )}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="To date"
            value={filter.date_iso_before}
            onChange={(value) => setFilter({ ...filter, date_iso_before: value })}
            renderInput={(params) => (
              <TextField fullWidth variant="outlined" {...params} />
            )}
          />
        </LocalizationProvider>
      </Stack>
    </Box>
  );
};

export default DatePanel;
